module.exports = __webpack_public_path__ + "static/media/0028_LES_ENSEIGNES_LA_BOULANGERIE_DES_SAVEURS.3af6b0d9.png";